const navigations = [
  {
    key: 'ecode',
    name: '云案例管理',
    pathname: '/ecodeDemo',
    icon: 'icon-Cloud-Logo',
    defaultKey: 'ecodeDemo',
    needAuth: true,
    subs: [{
      key: 'all',
      name: '全部案例',
      pathname: 'ecodeDemo/all',
    }, {
      key: 'success',
      name: '已通过',
      pathname: 'ecodeDemo/success',
    }, {
      key: 'fail',
      name: '未通过',
      pathname: 'ecodeDemo/fail',
    }, {
      key: 'applying',
      name: '审核中',
      pathname: 'ecodeDemo/applying',
    },{
      key: 'privateEcode',
      name: '私有案例',
      pathname: 'ecodeDemo/privateEcode',
    },{
      key: 'downloadlog',
      name: '下载日志',
      pathname: 'ecodeDemo/downloadlog',
    }, {
      key: 'tagmanage',
      name: '标签管理',
      pathname: 'ecodeDemo/tagmanage',
    }, {
      key: 'demorenew',
      name: '案例恢复',
      pathname: 'ecodeDemo/demorenew',
    }, {
      key: 'cusdownloadlog',
      name: '客户下载日志',
      pathname: 'ecodeDemo/cusdownloadlog',
    },{
      key: 'memberlist',
      name: '添加协作人',
      pathname: 'ecodeDemo/memberlist'

    },{
      key: 'ecoderole',
      name: '协作人管理',
      pathname: 'ecodeDemo/ecoderole'
    },
    // {
    //   key: 'appmanage',
    //   name: '应用管理',
    //   pathname: 'ecodeDemo/appmanage'
    // }
    {
      key: 'ecodegenre',
      name: '行业职能管理',
      pathname: 'ecodeDemo/ecodegenre'
    },
  ]
  },{
    key: 'app',
    name: '我的应用',
    pathname: '/app',
    icon: 'icon-Cloud-My-application',
    defaultKey: 'order',
    subs: [{
        key: 'order',
        name: '我的订单',
        pathname: '/app/order',
        query: {
          id: 'workflow'
        },
        subs: [{
            key: 'orderworkflow',
            name: '流程表单',
            pathname: '/app/order',
            query: {
              id: 'workflow'
            }
          },
          {
            key: 'orderapp',
            name: '应用订单',
            pathname: '/app/order',
            query: {
              id: 'app'
            }
          },
          // {
          //   key: 'orderecode',
          //   name: 'ecode订单',
          //   pathname: '/app/order',
          //   query: {
          //     id: 'ecode'
          //   }
          // },
          // { key: 'ordertheme', name: '门户主题', pathname: '/app/order', query: { id: 'theme' } },
          // { key: 'ordermode', name: '建模模板', pathname: '/app/order', query: { id: 'mode' } },
          // { key: 'orderdev', name: '定制开发', pathname: '/app/order', query: { id: 'dev' } },
          // { key: 'ordernStandard', name: '非标应用', pathname: '/app/order', query: { id: 'nStandard' } },
        ]
      }, {
        key: 'collect',
        name: '我的收藏',
        pathname: '/app/collect',
        query: {
          id: 'workflow'
        },
        subs: [{
            key: 'mycollection',
            name: 'ecode收藏',
            pathname: '/app/collect/mycollection',
            query: {
              id: ''
            }
          },
          {
            key: 'collectworkflow',
            name: '流程表单',
            pathname: '/app/collect',
            query: {
              id: 'workflow'
            }
          },
          {
            key: 'collecttheme',
            name: '门户主题',
            pathname: '/app/collect',
            query: {
              id: 'theme'
            }
          },
          {
            key: 'collectmode',
            name: '建模模板',
            pathname: '/app/collect',
            query: {
              id: 'mode'
            }
          },
          {
            key: 'collectdev',
            name: '定制开发',
            pathname: '/app/collect',
            query: {
              id: 'dev'
            }
          },
          {
            key: 'collectnStandard',
            name: '非标应用',
            pathname: '/app/collect',
            query: {
              id: 'nStandard'
            }
          },
        ]
      },
      // {
      //   key: 'price',
      //   name: '应用报价',
      //   pathname: '/app/price',
      // },
    ]
  }, {
    key: 'manager',
    name: '应用管理',
    pathname: '/manager',
    needAuth: true,
    open: 'admin',
    icon: 'icon-Cloud-Application-management',
    subs: [{
      key: 'price',
      name: '报价维护',
      open: 'admin',
      pathname: '/manager/price',
    },{
      key: 'appInfo',
      open: 'admin',
      name: '应用信息维护',
      pathname: '/manager/appInfo',
    }, ]
  },
  // {
  //   key: 'setting',
  //   name: '系统设置',
  //   pathname: '/setting',
  //   icon: 'icon-Cloud-System-setup',
  //   subs: [{
  //     key: 'authority',
  //     name: '权限设置',
  //     pathname: '/setting/authority',
  //   }, ]
  // },
  {
    key: 'dev',
    name: '开发者',
    pathname: '/dev',
    icon: 'icon-Cloud-Developer',
    subs: [
      {
        key: 'ecodeDev',
        name: 'ecode授权',
        pathname: '/dev/ecodeDev',
      },
      {
        key: 'list',
        name: '应用维护(E8)',
        needAuth: true,
        pathname: '/dev/list',
      },
    ],
  },
  // {
  //     key: 'log',
  //     name: '系统日志',
  //     pathname: '/log',
  //     icon: 'icon-Cloud-Project',
  //     subs: [
  //         {
  //             key: 'query',
  //             name: '日志查询',
  //             pathname: '/log/query',
  //         },
  //     ]
  // }
  // {
  //   key: 'oc',
  //   name: '社区',
  //   needAuth: true,
  //   pathname: '/oc',
  //   icon: 'icon-Cloud-Community',
  //   defaultKey: 'ques_1',
  //   subs: [{
  //     key: 'ques',
  //     name: '常见问题',
  //     pathname: 'oc/ques',
  //     subs: [{
  //       key: 'ques_1',
  //       name: '如何发布应用',
  //       pathname: 'oc/ques/ques_1',
  //     }],
  //   }, {
  //     key: 'devDoc',
  //     name: '开发文档',
  //     pathname: 'oc/devDoc',
  //     subs: [{
  //       key: 'devDoc_1',
  //       name: '开发规范',
  //       pathname: 'oc/devDoc/devDoc_1',
  //     }],
  //   }, {
  //     key: 'componentDoc',
  //     name: '组件文档',
  //     pathname: 'oc/componentDoc',
  //     subs: [{
  //       key: 'basic',
  //       name: '基础组件',
  //       pathname: 'oc/componentDoc/basic',
  //     }, {
  //       key: 'business',
  //       name: '业务组件',
  //       pathname: 'oc/componentDoc/business',
  //     }],
  //   }],
  // },
   {
    key: 'sys',
    name: '后台',
    pathname: '/sys',
    icon: 'icon-Cloud-Backstage',
    subs: [{
      key: 'basic',
      name: '基础管理',
      pathname: 'sys/basic',
      subs: [{
        key: 'user',
        name: '基本信息',
        pathname: 'sys/basic/user',
      }, {
        key: 'userPwd',
        name: '密码修改',
        pathname: 'sys/basic/userPwd',
      }]
    }, {
      key: 'user',
      name: '用户管理',
      pathname: 'sys/user',
      subs: [{
        key: 'userList',
        name: '用户列表',
        pathname: 'sys/user/userList',
      }, {
        key: 'userOnlineList',
        name: '登录状态',
        open: 'admin',
        pathname: 'sys/user/userOnlineList',
      }, {
        key: 'userDevApplyList',
        name: '开发者审核',
        open: 'none',
        pathname: 'sys/user/userDevApplyList',
      }, {
        key: 'joinList',
        name: '注册列表',
        open: 'admin',
        pathname: 'sys/user/joinList',
      }]
    }, {
      key: 'app',
      name: '应用管理',
      pathname: 'sys/app',
      subs: [{
        key: 'appApplyList',
        name: '订单审核',
        open: 'admin',
        pathname: 'sys/app/appApplyList',
      }, {
        key: 'devApplyList',
        name: '发布审核',
        open: 'admin',
        pathname: 'sys/app/devApplyList',
      }, {
        key: 'fbAppList',
        name: '非标应用',
        open: 'admin',
        pathname: 'sys/app/fbAppList',
      }]
    }, {
      key: 'sysManager',
      name: '系统管理',
      pathname: 'sys/sysManager',
      subs: [{
        key: 'publish',
        name: '发布版本',
        open: 'admin',
        pathname: 'sys/sysManager/publish',
      }, {
        key: 'module',
        name: '类别管理',
        open: 'admin',
        pathname: 'sys/sysManager/module',
      }, {
        key: 'ind',
        name: '行业管理',
        open: 'admin',
        pathname: 'sys/sysManager/ind',
      }]
    }, {
      key: 'statistics',
      name: '访问统计',
      pathname: 'sys/statistics',
      subs: [{
        key: 'barchart',
        name: '访问量',
        open: 'admin',
        pathname: 'sys/statistics/barchart',
      }]
    }],
  },
];
export default navigations;


// WEBPACK FOOTER //
// ./src/components/home/navigations.js